import { StoryNodeDisplayType } from "../../storyV2/domain/StoryNodeDisplayType";
import { ChainRequest } from "./transfromService/chain/ChainRequest";
import { AskBrainHandler } from "./transfromService/handler/AskBrainHandler";
import { BlobHandler } from "./transfromService/handler/BlobHandler";
import { UrlHandler } from "./transfromService/handler/UrlHandler";
import { StreamHandler } from "./transfromService/handler/StreamHandler";
import { JsonHandler } from "./transfromService/handler/JsonHandler";
import { TransformServiceHandlerChain } from "./transfromService/chain/TransformServiceHandlerChain";
import { CustomApiTransformUtil } from "./transfromService/util/CustomApiTransformUtil";
import { GlobalResponse } from "../../cutil/GlobalClient";
import { WSHandler } from "./transfromService/handler/WSHandler";
export class CustomApiTransfromService {
    constructor(brainClient) {
        this.brainClient = brainClient;
    }
    typeTransform(res) {
        if (res instanceof GlobalResponse) {
            const displayType = CustomApiTransformUtil.getDisplayTypeByHeaders(res.headers);
            if (CustomApiTransformUtil.isUploadFileType(displayType)) {
                return StoryNodeDisplayType.TEXT;
            }
            return displayType;
        }
        else {
            if (CustomApiTransformUtil.isUploadFileType(res.displayType)) {
                return StoryNodeDisplayType.TEXT;
            }
            return res.displayType;
        }
    }
    async contentTransform(query, res) {
        const chainRequest = new ChainRequest(query, res);
        const chain = new TransformServiceHandlerChain();
        chain.addHandler(new WSHandler(this.brainClient));
        chain.addHandler(new AskBrainHandler());
        chain.addHandler(new UrlHandler(this.brainClient));
        chain.addHandler(new BlobHandler(this.brainClient));
        chain.addHandler(new StreamHandler());
        chain.addHandler(new JsonHandler());
        await chain.process(chainRequest);
        return chainRequest.getResult();
    }
}
